import { Program } from '../models/program'
import { Song } from '../models/song'
import { mockBackend } from './environment'
import axios from 'axios'
import { Now, Request } from '../models/now'

let mockVersion = 1

export function progress (now: Now) {
  const elapsedDuration = Date.now() - now.date
  const progress = elapsedDuration / (now.song.duration * 1000)
  return Math.max(0, Math.min(progress, 1))
}

export function endDate (now: Now) {
  return now.date + now.song.duration * 1000
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function parseNow (json: any): Now {
  const song: Song = {
    id: json.id,
    artist: json.artists.main.alias,
    title: json.name,
    year: json.year,
    cover: json.covers.main,
    duration: json.length.raw
  }
  const program: Program = {
    id: json.now.program.id,
    name: json.now.program.name
  }
  const elapsedPercentage = json.now.elapsed_pcent as number
  const elapsedDuration = song.duration / 100 * elapsedPercentage
  const startDate = Date.now() - elapsedDuration * 1000
  let request: Request | undefined
  if (json.now.request && json.now.request.user_id) {
    request = {
      userId: json.now.request.user_id,
      user: json.now.request.user_login,
      dedication: json.now.request.dedication
    }
  }
  return {
    song,
    program,
    listeners: json.now.nb_listeners as number,
    date: startDate.valueOf(),
    request: request
  }
}

export async function currentProgram (): Promise<Now> {
  let url: string
  if (mockBackend()) {
    if (mockVersion === 1) {
      url = '/mock-backend/now.json'
      mockVersion = 2
    } else {
      url = '/mock-backend/now2.json'
      mockVersion = 1
    }
  } else {
    url = '/wapi/now.php'
  }
  const json = (await axios.get(url)).data
  return parseNow(json)
}
